import { Component } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-select',
    templateUrl: './form-factory-field-select.component.html',
    styleUrls: ['./form-factory-field-select.component.scss'],
})
export class FormFactoryFieldSelectComponent extends FormFieldFactoryComponentAbstract {}
